/**
 * Emails « techniques » générés côté serveur quand une préréservation est saisie
 * au téléphone sans adresse réelle — voir `backend::models::TECH_RESERVATION_EMAIL_SUFFIX`
 * et `is_technical_reservation_email`.
 */
export const TECH_RESERVATION_EMAIL_SUFFIX = '@local.sqseverac.invalid';

export const RESERVATION_EMAIL_NO_ADDRESS_LABEL = "Pas d'email (téléphone)";

export function isTechnicalReservationEmail(email) {
  return typeof email === 'string' && email.endsWith(TECH_RESERVATION_EMAIL_SUFFIX);
}

/** Libellé affichable à la place de l'adresse technique (tableaux, fiches, etc.). */
export function formatReservationEmailDisplay(email) {
  if (typeof email !== 'string' || !email) return '';
  return isTechnicalReservationEmail(email) ? RESERVATION_EMAIL_NO_ADDRESS_LABEL : email;
}
